/**
 * 搜索范围下拉列表
 */
export const searchOptions = [{ field: 1, value: '', logic: 'and', key: Math.random() }]

/**
 * 搜索字段id与label映射表
 */
export const searchField = [
  { field: 1, label: '题名' },
  { field: 37, label: '朝代' },
  { field: 34, label: '文保级别' },
  { field: 29, label: '行政区划' }
]
